var config = require("../config.js");
const UTILS = require("../libs/utils.js");
var classes = require("./classes.js");
var weapons = require("./weapons.js");
var effects = require("./effects.js");
const vA389 = ["nuke_0", 1, 1, 0, false];
module.exports.events = [{
  name: "onShoot",
  desc: "REPLACE"
}, {
  name: "onMelee",
  desc: "REPLACE"
}, {
  name: "onDamage",
  desc: "REPLACE"
}, {
  name: "onEnterObject",
  desc: "REPLACE"
}, {
  name: "onDestroy",
  desc: "REPLACE"
}, {
  name: "onRespawn",
  desc: "REPLACE"
}, {
  name: "onTimer",
  desc: "REPLACE"
}, {
  name: "onProjectile",
  desc: "REPLACE"
}, {
  name: "onThrowingMelee",
  desc: "REPLACE"
}, {
  name: "onPunch",
  desc: "REPLACE"
}, {
  name: "onHoldMouse",
  desc: "REPLACE"
}, {
  name: "onCollision",
  desc: "REPLACE"
}, {
  name: "onStorageEquals",
  desc: "REPLACE"
}, {
  name: "onStorageGreater",
  desc: "REPLACE"
}, {
  name: "onStorageLesser",
  desc: "REPLACE"
}, {
  name: "onAIDeath",
  desc: "REPLACE"
}, {
  name: "onInteractKey",
  desc: "REPLACE"
}, {
  name: "onPlayerSpawn",
  desc: "REPLACE"
}, {
  name: "onPlayerKill",
  desc: "REPLACE"
}, {
  name: "onPlayerDie",
  desc: "REPLACE"
}, {
  name: "onAIDamage",
  desc: "REPLACE"
}, {
  name: "onNukeStart",
  desc: "REPLACE"
}, {
  name: "onNukeEnd",
  desc: "REPLACE"
}, {
  name: "onExitObject",
  desc: "REPLACE"
}, {
  name: "onCustomValEquals",
  desc: "REPLACE"
}, {
  name: "onCustomValLesser",
  desc: "REPLACE"
}, {
  name: "onGameStart",
  desc: "REPLACE"
}, {
  name: "onObjectiveSwitch",
  desc: "REPLACE"
}, {
  name: "onPlayerDamage",
  desc: "REPLACE"
}, {
  name: "onAIHalfHealth",
  desc: "REPLACE"
}, {
  name: "onCustomValGreater",
  desc: "REPLACE"
}, {
  name: "onAIKillPlayer",
  desc: "REPLACE"
}];
module.exports.conditions = [{
  name: "None",
  desc: "REPLACE",
  check: function () {
    return true;
  }
}, {
  name: "Player Value",
  desc: "REPLACE",
  vals: [{
    name: "Key",
    def: "",
    input: true,
    len: 10
  }, {
    name: "Type",
    def: 0,
    select: ["Equal", "Not Equal", "Greater than", "Greater or Equal", "Less than", "Less or Equal"]
  }, {
    name: "Val",
    def: 0,
    min: 0,
    max: 1000,
    step: 0.01
  }],
  check: function (p9369, p9370, p9371, p9372, p9373) {
    if (!p9371 || !p9373) {
      return false;
    }
    var v7819 = p9373.trigCond[1] + "";
    var v7820 = p9373.trigCond[2];
    var v7821 = p9373.trigCond[3];
    var vLN01265 = 0;
    vLN01265 = config.playerVals.indexOf(v7819) > -1 ? p9371[v7819] : p9371.custVals ? p9371.custVals[v7819] || 0 : 0;
    return UTILS.compareVal(v7820, vLN01265, v7821);
  }
}, {
  name: "Current Class",
  desc: "REPLACE",
  vals: [{
    name: "Class",
    def: 0,
    select: Object.keys(classes).map(function (p9374) {
      return classes[p9374].name;
    })
  }],
  check: function (p9375, p9376, p9377, p9378, p9379) {
    if (!p9377 || !p9379) {
      return false;
    }
    var v7822 = parseInt(p9379.trigCond[1]) || 0;
    return p9377.classIndex == v7822;
  }
}, {
  name: "Trigger Value",
  desc: "REPLACE",
  vals: [{
    name: "Key",
    def: "",
    input: true,
    len: 10
  }, {
    name: "Type",
    def: 0,
    select: ["Equal", "Not Equal", "Greater than", "Greater or Equal", "Less than", "Less or Equal"]
  }, {
    name: "Val",
    def: 0,
    min: 0,
    max: 1000,
    step: 0.01
  }],
  check: function (p9380, p9381, p9382, p9383, p9384) {
    if (!p9383 || !p9382 || !p9384) {
      return false;
    }
    var v7823 = p9384.trigCond[1] + "";
    var v7824 = p9384.trigCond[2];
    var v7825 = p9384.trigCond[3];
    var v7826 = p9383.custVals ? p9383.custVals[v7823] || 0 : 0;
    return UTILS.compareVal(v7824, v7826, v7825);
  }
}, {
  name: "Player Count",
  desc: "REPLACE",
  vals: [{
    name: "Type",
    def: 0,
    select: ["Equal", "Not Equal", "Greater than", "Greater or Equal", "Less than", "Less or Equal"]
  }, {
    name: "Filter",
    def: 0,
    select: ["Active", "Spectating", "Overall Connected"]
  }, {
    name: "Amount",
    def: 0,
    min: 0,
    max: 50,
    step: 1
  }],
  check: function (game, p9386, p9387, p9388, p9389) {
    if (!p9388 || !p9389 || !game) {
      return false;
    }
    var v7827 = p9389.trigCond[1];
    var v7828 = p9389.trigCond[2];
    var v7829 = p9389.trigCond[3];
    var vLN01266 = 0;
    if (v7828 == 0) {
      vLN01266 = game.players.list.filter(plr => plr && plr.active).length || 0;
    } else if (v7828 == 1) {
      vLN01266 = game.players.list.filter(plr => plr && plr.spectating).length || 0;
    } else if (v7828 == 2) {
      vLN01266 = game.connectedClients || 0;
    }
    return UTILS.compareVal(v7827, vLN01266, v7829);
  }
}, {
  name: "Global Value",
  desc: "REPLACE",
  vals: [{
    name: "Key",
    def: "",
    input: true,
    len: 10
  }, {
    name: "Type",
    def: 0,
    select: ["Equal", "Not Equal", "Greater than", "Greater or Equal", "Less than", "Less or Equal"]
  }, {
    name: "Val",
    def: 0,
    min: 0,
    max: 1000,
    step: 0.01
  }],
  check: function (p9392, p9393, p9394, p9395, p9396) {
    if (!p9395 || !p9394 || !p9396) {
      return false;
    }
    var v7830 = p9396.trigCond[1] + "";
    var v7831 = p9396.trigCond[2];
    var v7832 = p9396.trigCond[3];
    var v7833 = p9392.globalVals ? p9392.globalVals[v7830] || 0 : 0;
    return UTILS.compareVal(v7831, v7833, v7832);
  }
}, {
  name: "Player has Account",
  desc: "REPLACE",
  check: function (p9397, p9398, p9399, p9400, p9401) {
    return !!p9399 && !!p9401 && !!p9399.account;
  }
}, {
  name: "Player has Premium",
  desc: "REPLACE",
  check: function (p9402, p9403, p9404, p9405, p9406) {
    return !!p9404 && !!p9406 && !!p9404.account && !!(p9404.account.premiumT > 0);
  }
}, {
  name: "Player is Verified",
  desc: "REPLACE",
  check: function (p9407, p9408, p9409, p9410, p9411) {
    return !!p9409 && !!p9411 && !!p9409.account && !!p9409.account.featured;
  }
}, {
  name: "Player is Partner",
  desc: "REPLACE",
  check: function (p9412, p9413, p9414, p9415, p9416) {
    return !!p9414 && !!p9416 && !!p9414.account && !!(p9414.account.partnerApp >= 2);
  }
}, {
  name: "Player Level",
  desc: "REPLACE",
  vals: [{
    name: "Type",
    def: 0,
    select: ["Equal", "Not Equal", "Greater than", "Greater or Equal", "Less than", "Less or Equal"]
  }, {
    name: "Level",
    def: 0,
    min: 0,
    max: 1000,
    step: 1
  }],
  check: function (p9417, p9418, p9419, p9420, p9421) {
    if (!p9419 || !p9421) {
      return false;
    }
    var v7834 = p9421.trigCond[1];
    var v7835 = parseInt(p9421.trigCond[2]) || 0;
    var v7836 = p9419.account ? p9419.account.level || 0 : 0;
    return UTILS.compareVal(v7834, v7836, v7835);
  }
}, {
  name: "Player Inventory Value",
  desc: "REPLACE",
  vals: [{
    name: "Type",
    def: 0,
    select: ["Equal", "Not Equal", "Greater than", "Greater or Equal", "Less than", "Less or Equal"]
  }, {
    name: "Val",
    def: 0,
    min: 0,
    max: 100000000,
    step: 1000
  }],
  check: function (p9422, p9423, p9424, p9425, p9426) {
    if (!p9424 || !p9426) {
      return false;
    }
    var v7837 = p9426.trigCond[1];
    var v7838 = parseInt(p9426.trigCond[2]) || 0;
    var v7839 = p9424.account ? p9424.account.invVal || 0 : 0;
    return UTILS.compareVal(v7837, v7839, v7838);
  }
}];
module.exports.actions = [{
  name: "Give Player Score",
  desc: "REPLACE",
  hasCust: true,
  execute: function (game, p9428, p9429, p9430, p9431) {
    if (p9429) {
      var v7840 = game.getActionValue(p9429, p9430, p9431, "number", p9431.trigConst || 1);
      if (v7840 != null) {
        game.players.score(p9429, v7840);
      }
    }
  }
}, {
  name: "Kill Player",
  desc: "REPLACE",
  execute: function (game, p9433, p9434) {
    if (p9434) {
      if (!p9434.godMode) {
        game.players.kill(p9434);
      }
    }
  }
}, {
  name: "Respawn Player",
  desc: "REPLACE",
  execute: function (game, p9436, p9437) {
    if (p9437) {
      var v7841 = p9437 ? p9437.checkPoint : null;
      var v7842 = v7841 && game.map.manager.objects[v7841] ? game.map.manager.objects[v7841] : game.getSpawnPoint(p9437.team, p9437);
      game.players.changePosition(p9437, v7842.x, v7842.y, v7842.z, true, false, undefined, true);
    }
  }
}, {
  name: "Change Player Health",
  desc: "REPLACE",
  hasCust: true,
  execute: function (game, p9439, p9440, p9441, p9442) {
    if (p9440) {
      var v7843 = game.getActionValue(p9440, p9441, p9442, "number", p9442.trigConst || 0);
      if (v7843 != null) {
        if (game.players.changeHealth(p9440, null, -v7843, true)) {
          game.players.kill(p9440);
        }
      }
    }
  }
}, {
  name: "Destroy Interface",
  desc: "REPLACE",
  execute: function (p9443, p9444, p9445, p9446, p9447, p9448) {
    for (var vLN01267 = 0; vLN01267 < p9443.map.manager.interfaces.length && !(p9443.triggerChains[p9448] <= 0); ++vLN01267) {
      var v7844 = p9443.map.manager.objects[p9443.map.manager.interfaces[vLN01267]];
      if ((p9446.isAI || v7844.sid != p9446.sid) && (v7844.health || v7844.gate || v7844.canDest && !v7844.destroyed) && v7844.interface != p9446.interface && v7844.interface == p9446.interfaceT) {
        v7844.active = false;
        if (v7844.gate) {
          p9443.broadcast("gte", v7844.uid, v7844.active);
        } else {
          v7844.health = 0;
          v7844.destroyedBy = p9445;
          v7844.destroyed = true;
          p9443.map.manager.destObjs.push(v7844.uid);
          p9443.broadcast("do", v7844.uid);
        }
        if (v7844.onDestroy || v7844.onDamage) {
          p9443.onTrigger(p9445, v7844, p9448);
        }
      }
    }
  }
}, {
  name: "Toggle Interface Gate",
  desc: "REPLACE",
  execute: function (p9449, p9450, p9451, p9452) {
    var v7845;
    for (var vLN01268 = 0; vLN01268 < p9449.map.manager.interfaces.length; ++vLN01268) {
      v7845 = p9449.map.manager.objects[p9449.map.manager.interfaces[vLN01268]];
      if ((p9452.isAI || v7845.sid != p9452.sid) && v7845.gate && v7845.interface != p9452.interface && v7845.interface == p9452.interfaceT) {
        v7845.active = !v7845.active;
        p9449.broadcast("gte", v7845.uid, v7845.active);
      }
    }
  }
}, {
  name: "Change Interface Health",
  desc: "REPLACE",
  hasCust: true,
  execute: function (p9453, p9454, p9455, p9456, p9457, p9458) {
    for (var vLN01269 = 0; vLN01269 < p9453.map.manager.interfaces.length && !(p9453.triggerChains[p9458] <= 0); ++vLN01269) {
      var v7846 = p9453.map.manager.objects[p9453.map.manager.interfaces[vLN01269]];
      if ((p9456.isAI || v7846.sid != p9456.sid) && v7846.health && v7846.canDest && !v7846.destroyed && v7846.interface != p9456.interface && v7846.interface == p9456.interfaceT) {
        var v7847 = p9453.getActionValue(p9455, v7846, p9457, "number", p9457.trigConst || 0);
        if (v7847 == null) {
          continue;
        }
        v7846.health -= -v7847;
        if (v7846.health <= 0) {
          v7846.active = false;
          v7846.health = 0;
          v7846.destroyedBy = p9455;
          v7846.destroyed = true;
          p9453.map.manager.destObjs.push(v7846.uid);
          p9453.broadcast("do", v7846.uid);
          if (v7846 && v7846.onDestroy) {
            p9453.onTrigger(p9455, v7846, p9458);
          }
        }
        if (v7846 && v7846.onDamage && (p9457.trigConst || 0) < 0) {
          p9453.onTrigger(p9455, v7846, p9458);
        }
      }
    }
  }
}, {
  name: "Teleport Player To Interface",
  desc: "REPLACE",
  execute: function (game, p9460, p9461, p9462, p9463, p9464) {
    if (p9461) {
      var v7848;
      for (var vLN01270 = 0; vLN01270 < game.map.manager.interfaces.length && !(game.triggerChains[p9464] <= 0); ++vLN01270) {
        v7848 = game.map.manager.objects[game.map.manager.interfaces[vLN01270]];
        if ((p9462.isAI || v7848.sid != p9462.sid) && (v7848.interface == null || v7848.interface == null || v7848.interface != p9462.interface) && v7848.interface == p9462.interfaceT) {
          game.players.changePosition(p9461, v7848.x, v7848.y - v7848.height, v7848.z, true, true, undefined, true);
        }
      }
    }
  }
}, {
  name: "Change Interface Deposit Box Amount",
  desc: "REPLACE",
  hasCust: true,
  execute: function (p9465, p9466, p9467, p9468, p9469, p9470) {
    for (var vLN01271 = 0; vLN01271 < p9465.map.manager.interfaces.length && !(p9465.triggerChains[p9470] <= 0); ++vLN01271) {
      var v7849 = p9465.map.manager.objects[p9465.map.manager.interfaces[vLN01271]];
      if ((p9468.isAI || v7849.sid != p9468.sid) && v7849.interface != p9468.interface && v7849.interface == p9468.interfaceT && v7849.bank) {
        var v7850 = p9465.getActionValue(p9467, v7849, p9469, "number", p9469.trigConst || 0);
        if (v7850 == null) {
          continue;
        }
        if (v7849.deposited == null) {
          v7849.deposited = 0;
        }
        v7849.deposited += v7850;
        p9465.broadcast("bnk", v7849.uid, v7849.deposited);
      }
    }
  }
}, {
  name: "Kill Opposing Team",
  desc: "REPLACE",
  execute: function (game, p9472, p9473) {
    if (p9473) {
      var v7851;
      for (var vLN01272 = 0; vLN01272 < game.players.list.length; ++vLN01272) {
        v7851 = game.players.list[vLN01272];
        if (!!v7851.active && v7851 != p9473 && !v7851.godMode && (!v7851.team || p9473.team != v7851.team)) {
          game.players.kill(v7851, null, null, true);
        }
      }
    }
  }
}, {
  name: "Respawn Opposing Team",
  desc: "REPLACE",
  execute: function (game, p9475, p9476) {
    if (p9476) {
      var v7852;
      for (var vLN01273 = 0; vLN01273 < game.players.list.length; ++vLN01273) {
        v7852 = game.players.list[vLN01273];
        if (v7852.active && v7852 != p9476 && (!v7852.team || p9476.team != v7852.team)) {
          var v7853 = v7852 ? v7852.checkPoint : null;
          var v7854 = v7853 && game.map.manager.objects[v7853] ? game.map.manager.objects[v7853] : game.getSpawnPoint(v7852.team, v7852);
          game.players.changePosition(v7852, v7854.x, v7854.y, v7854.z, true, false, undefined, true);
        }
      }
    }
  }
}, {
  name: "Respawn Destructible Interface",
  desc: "REPLACE",
  execute: function (p9477, p9478, p9479, p9480, p9481, p9482) {
    for (var vLN01274 = 0; vLN01274 < p9477.map.manager.interfaces.length && !(p9477.triggerChains[p9482] <= 0); ++vLN01274) {
      var v7855 = p9477.map.manager.objects[p9477.map.manager.interfaces[vLN01274]];
      var v7856 = p9477.map.manager.destObjs.indexOf(v7855.uid);
      if ((p9480.isAI || v7855.sid != p9480.sid) && (v7855.startHealth || v7855.canDest && v7855.destroyed) && v7855.destroyed && v7856 != -1 && v7855.interface != p9480.interface && v7855.interface == p9480.interfaceT) {
        v7855.destroyed = false;
        p9477.map.manager.destObjs.splice(v7856, 1);
        v7855.active = true;
        v7855.respawnT = v7855.respawnR ? 0 : v7855.respawnTStart;
        if (v7855.health != null) {
          v7855.health = v7855.startHealth;
        }
        p9477.broadcast("ro", v7855.uid);
        if (v7855 && v7855.onRespawn) {
          p9477.onTrigger(v7855.destroyedBy, v7855, p9482);
        }
        v7855.destroyedBy = null;
      }
    }
  }
}, {
  name: "Toggle Destructible Interface",
  desc: "REPLACE",
  execute: function (p9483, p9484, p9485, p9486, p9487, p9488) {
    for (var vLN01275 = 0; vLN01275 < p9483.map.manager.interfaces.length && !(p9483.triggerChains[p9488] <= 0); ++vLN01275) {
      var v7857 = p9483.map.manager.objects[p9483.map.manager.interfaces[vLN01275]];
      var v7858 = p9483.map.manager.destObjs.indexOf(v7857.uid);
      if ((p9486.isAI || v7857.sid != p9486.sid) && (v7857.startHealth || v7857.canDest) && v7857.interface != p9486.interface && v7857.interface == p9486.interfaceT) {
        if (v7858 == -1) {
          v7857.active = false;
          v7857.health = 0;
          v7857.destroyed = true;
          v7857.destroyedBy = p9485;
          p9483.map.manager.destObjs.push(v7857.uid);
          p9483.broadcast("do", v7857.uid);
          if (v7857.onDestroy || v7857.onDamage) {
            p9483.onTrigger(p9485, v7857, p9488);
          }
        } else {
          p9483.map.manager.destObjs.splice(v7858, 1);
          v7857.active = true;
          v7857.destroyed = false;
          v7857.respawnT = v7857.respawnR ? 0 : v7857.respawnTStart;
          if (v7857.health != null) {
            v7857.health = v7857.startHealth;
          }
          p9483.broadcast("ro", v7857.uid);
          if (v7857 && v7857.onRespawn) {
            p9483.onTrigger(v7857.destroyedBy, v7857, p9488);
          }
          v7857.destroyedBy = null;
        }
      }
    }
  }
}, {
  name: "Set Player Score",
  desc: "REPLACE",
  hasCust: true,
  execute: function (game, p9490, p9491, p9492, p9493) {
    if (p9491) {
      var v7859 = game.getActionValue(p9491, p9492, p9493, "number", p9493.trigConst || 0);
      if (v7859 != null) {
        game.players.score(p9491, v7859, 0, true);
      }
    }
  }
}, {
  name: "Broadcast Sound",
  desc: "REPLACE",
  hasSound: true,
  execute: function (p9494, p9495, p9496, p9497, p9498) {
    var v7860 = p9498.triggerSound || vA389;
    if (v7860[3] == 2) {
      p9494.broadcast("so", v7860[0] || "nuke_0", v7860[1] || 1, 1, 0, 0, 0, v7860[2] || 1, null, null, !!v7860[4]);
    } else {
      var v7861 = v7860[3] && p9496;
      var v7862 = v7861 ? p9496 : p9497;
      p9494.playSound(v7860[0] || "nuke_0", v7860[1] || 1, v7862.sid, v7862.x, v7861 ? v7862.y + v7862.height : v7862.y, v7862.z, true, v7860[2] || 1, false, null, null, !v7861, !!v7860[4]);
    }
  }
}, {
  name: "Clear Player Loadout",
  desc: "REPLACE",
  execute: function (p9499, p9500, p9501) {
    if (p9501 && (p9501.loadout.length != 1 || p9501.loadout[0] != 12)) {
      p9501.updateLoadout(p9499, 0, true, [12]);
      p9499.broadcast("inat", p9501.sid, [12], 0, undefined, undefined, false);
    }
  }
}, {
  name: "Broadcast Message",
  desc: "REPLACE",
  type: "Text",
  actionValueTxt: "Message",
  execute: function (p9502, p9503, p9504, p9505, p9506) {
    if (p9506.trigConstTx && p9506.trigConstTx.length) {
      p9502.broadcast("ch", -1, null, p9506.trigConstTx, 2);
    }
  }
}, {
  name: "Send Message",
  desc: "REPLACE",
  type: "Text",
  actionValueTxt: "Message",
  execute: function (p9507, p9508, p9509, p9510, p9511) {
    if (p9509 && p9511.trigConstTx && p9511.trigConstTx.length) {
      p9509.send("ch", -1, null, p9511.trigConstTx, 2);
    }
  }
}, {
  name: "Swap Player Team",
  desc: "REPLACE",
  execute: function (p9512, p9513, p9514) {
    if (p9514) {
      var v7863 = p9514.team == 2 ? 1 : 2;
      p9512.updateTeam(p9514, v7863);
    }
  }
}, {
  name: "Set Player Team",
  desc: "REPLACE",
  execute: function (p9515, p9516, p9517, p9518, p9519) {
    if (p9517) {
      var v7864 = parseInt(p9519.trigConst) || 0;
      v7864 = UTILS.limitMM(v7864, 1, config.teamLimit);
      p9515.updateTeam(p9517, v7864);
    }
  }
}, {
  name: "Round Time",
  desc: "REPLACE",
  execute: function (p9520, p9521, p9522, p9523, p9524) {
    if (UTILS.isNumber(p9520.gameTimer)) {
      var v7865 = p9524.trigConst || 0;
      p9520.gameTimer += v7865;
      if (p9520.gameTimer <= 0) {
        p9520.gameTimer = "skip";
      }
    }
  }
}, {
  name: "Reset Interface",
  desc: "REPLACE",
  execute: function (p9525, p9526, p9527, p9528, p9529, p9530) {
    for (var vLN01276 = 0; vLN01276 < p9525.map.manager.interfaces.length && !(p9525.triggerChains[p9530] <= 0); ++vLN01276) {
      var v7866 = p9525.map.manager.objects[p9525.map.manager.interfaces[vLN01276]];
      if ((p9528.isAI || v7866.sid != p9528.sid) && v7866.interface != p9528.interface && v7866.interface == p9528.interfaceT) {
        var v7867 = p9525.map.manager.destObjs.indexOf(v7866.uid);
        if (v7867 != -1) {
          p9525.map.manager.destObjs.splice(v7867, 1);
          v7866.respawnT = v7866.respawnR ? 0 : v7866.respawnTStart;
          if (v7866.health != null) {
            v7866.health = v7866.startHealth;
          }
          p9525.broadcast("ro", v7866.uid);
          if (v7866 && v7866.onRespawn) {
            p9525.onTrigger(v7866.destroyedBy, v7866, p9530);
          }
          v7866.destroyedBy = null;
        }
        v7866.trigT = (v7866.trigConstE || 1) * 1000;
        v7866.health = v7866.startHealth;
        v7866.destroyed = false;
        v7866.active = true;
        v7866.triggered = false;
        if (v7866.uses) {
          v7866.uses.length = 0;
        }
      }
    }
  }
}, {
  name: "End Round",
  desc: "REPLACE",
  execute: function (p9531) {
    if (p9531.gameTimer != "skip") {
      p9531.gameTimer = "skip";
    }
  }
}, {
  name: "Refill Player Knife",
  desc: "REPLACE",
  execute: function (p9532, p9533, p9534) {
    if (p9534 && p9534.refillKnife) {
      p9532.refillPlayer(p9534);
      p9534.send("rfl");
    }
  }
}, {
  name: "Destroy Self",
  desc: "REPLACE",
  execute: function (p9535, p9536, p9537, p9538, p9539, p9540) {
    if ((p9538.health || p9538.gate || p9538.canDest) && p9538.active) {
      p9538.active = false;
      if (p9538.gate) {
        p9535.broadcast("gte", p9538.uid, p9538.active);
      } else {
        p9538.health = 0;
        p9538.destroyed = true;
        p9538.destroyedBy = p9537;
        p9535.map.manager.destObjs.push(p9538.uid);
        p9535.broadcast("do", p9538.uid);
      }
      if (!p9538.selfDestruct && (p9538.onDestroy || p9538.onDamage)) {
        p9535.onTrigger(p9537, p9538, p9540);
      }
    }
  }
}, {
  name: "Increase Interface Storage",
  desc: "REPLACE",
  hasCust: true,
  execute: function (p9541, p9542, p9543, p9544, p9545, p9546) {
    for (var vLN01277 = 0; vLN01277 < p9541.map.manager.interfaces.length && !(p9541.triggerChains[p9546] <= 0); ++vLN01277) {
      var v7868 = p9541.map.manager.objects[p9541.map.manager.interfaces[vLN01277]];
      if ((p9544.isAI || v7868.sid != p9544.sid) && (v7868.onStorageEquals || v7868.onStorageGreater || v7868.onStorageLesser) && v7868.interface != p9544.interface && v7868.interface == p9544.interfaceT) {
        var v7869 = p9541.getActionValue(p9543, v7868, p9545, "number", p9545.trigConst || 0);
        if (v7869 == null) {
          continue;
        }
        if (v7868.storage == null) {
          v7868.storage = 0;
        }
        v7868.storage += v7869;
        if (v7868.storage == (v7868.trigConstE || 0) && v7868.onStorageEquals) {
          p9541.onTrigger(p9543, v7868, p9546);
        }
        if (v7868.storage > (v7868.trigConstE || 0) && v7868.onStorageGreater) {
          p9541.onTrigger(p9543, v7868, p9546);
        }
        if (v7868.storage < (v7868.trigConstE || 0) && v7868.onStorageLesser) {
          p9541.onTrigger(p9543, v7868, p9546);
        }
      }
    }
  }
}, {
  name: "Decrease Interface Storage",
  desc: "REPLACE",
  hasCust: true,
  execute: function (p9547, p9548, p9549, p9550, p9551, p9552) {
    for (var vLN01278 = 0; vLN01278 < p9547.map.manager.interfaces.length && !(p9547.triggerChains[p9552] <= 0); ++vLN01278) {
      var v7870 = p9547.map.manager.objects[p9547.map.manager.interfaces[vLN01278]];
      if ((p9550.isAI || v7870.sid != p9550.sid) && (v7870.onStorageEquals || v7870.onStorageGreater || v7870.onStorageLesser) && v7870.interface != p9550.interface && v7870.interface == p9550.interfaceT) {
        var v7871 = p9547.getActionValue(p9549, v7870, p9551, "number", p9551.trigConst || 0);
        if (v7871 == null) {
          continue;
        }
        if (v7870.storage == null) {
          v7870.storage = 0;
        }
        v7870.storage -= v7871;
        if (v7870.storage == (v7870.trigConstE || 0) && v7870.onStorageEquals) {
          p9547.onTrigger(p9549, v7870, p9552);
        }
        if (v7870.storage > (v7870.trigConstE || 0) && v7870.onStorageGreater) {
          p9547.onTrigger(p9549, v7870, p9552);
        }
        if (v7870.storage < (v7870.trigConstE || 0) && v7870.onStorageLesser) {
          p9547.onTrigger(p9549, v7870, p9552);
        }
      }
    }
  }
}, {
  name: "Set Interface Storage",
  desc: "REPLACE",
  hasCust: true,
  execute: function (p9553, p9554, p9555, p9556, p9557, p9558) {
    for (var vLN01279 = 0; vLN01279 < p9553.map.manager.interfaces.length && !(p9553.triggerChains[p9558] <= 0); ++vLN01279) {
      var v7872 = p9553.map.manager.objects[p9553.map.manager.interfaces[vLN01279]];
      if ((p9556.isAI || v7872.sid != p9556.sid) && (v7872.onStorageEquals || v7872.onStorageGreater || v7872.onStorageLesser) && v7872.interface != p9556.interface && v7872.interface == p9556.interfaceT) {
        var v7873 = p9553.getActionValue(p9555, v7872, p9557, "number", p9557.trigConst || 0);
        if (v7873 == null) {
          continue;
        }
        if (v7872.storage == null) {
          v7872.storage = 0;
        }
        v7872.storage = v7873;
        if (v7872.storage == (v7872.trigConstE || 0) && v7872.onStorageEquals) {
          p9553.onTrigger(p9555, v7872, p9558);
        }
        if (v7872.storage > (v7872.trigConstE || 0) && v7872.onStorageGreater) {
          p9553.onTrigger(p9555, v7872, p9558);
        }
        if (v7872.storage < (v7872.trigConstE || 0) && v7872.onStorageLesser) {
          p9553.onTrigger(p9555, v7872, p9558);
        }
      }
    }
  }
}, {
  name: "Reset Interface Storage",
  desc: "REPLACE",
  execute: function (p9559, p9560, p9561, p9562, p9563, p9564) {
    for (var vLN01280 = 0; vLN01280 < p9559.map.manager.interfaces.length && !(p9559.triggerChains[p9564] <= 0); ++vLN01280) {
      var v7874 = p9559.map.manager.objects[p9559.map.manager.interfaces[vLN01280]];
      if ((p9562.isAI || v7874.sid != p9562.sid) && (v7874.onStorageEquals || v7874.onStorageGreater) && v7874.interface != p9562.interface && v7874.interface == p9562.interfaceT) {
        v7874.storage = 0;
        if (v7874.storage == (v7874.trigConstE || 0) && v7874.onStorageEquals) {
          p9559.onTrigger(p9561, v7874, p9564);
        }
        if (v7874.storage > (v7874.trigConstE || 0) && v7874.onStorageGreater) {
          p9559.onTrigger(p9561, v7874, p9564);
        }
        if (v7874.storage < (v7874.trigConstE || 0) && v7874.onStorageLesser) {
          p9559.onTrigger(p9561, v7874, p9564);
        }
      }
    }
  }
}, {
  name: "Broadcast Popup",
  desc: "REPLACE",
  type: "Text",
  actionValueTxt: "Message",
  execute: function (p9565, p9566, p9567, p9568, p9569) {
    if (p9569.trigConstTx && p9569.trigConstTx.length) {
      p9565.broadcast("am", [p9569.trigConstTx + "", null, 0, 1]);
    }
  }
}, {
  name: "Send Popup",
  desc: "REPLACE",
  type: "Text",
  actionValueTxt: "Message",
  execute: function (p9570, p9571, p9572, p9573, p9574) {
    if (p9572 && p9574.trigConstTx && p9574.trigConstTx.length) {
      if (p9572.send) {
        p9572.send("am", [p9574.trigConstTx + "", null, 0, 1]);
      }
    }
  }
}, {
  name: "Jump Scare",
  desc: "REPLACE",
  execute: function (p9575, p9576, p9577) {
    if (p9577) {
      if (p9577.send) {
        p9577.send("scr", 0);
      }
    }
  }
}, {
  name: "Reward KR",
  desc: "REPLACE",
  actionValue: "KR Amount",
  execute: function (p9578, p9579, p9580, p9581, p9582) {
    if (p9580 && p9578.krRewards) {
      p9578.rewardKR(p9580, parseInt(p9582.trigConst || 0));
    }
  }
}, {
  name: "Clear Player Checkpoints",
  desc: "REPLACE",
  execute: function (p9583, p9584, p9585) {
    if (p9585) {
      p9585.checkPoint = null;
      if (p9585.checkPointList) {
        p9585.checkPointList.length = 0;
      }
      if (p9585.checkPointData) {
        p9585.checkPointData.length = 0;
      }
      if (p9585.send) {
        p9585.send("chp", true);
      }
    }
  }
}, {
  name: "Send Sound",
  desc: "REPLACE",
  hasSound: true,
  execute: function (p9586, p9587, p9588, p9589, p9590) {
    if (p9588) {
      var v7875 = p9590.triggerSound || vA389;
      if (v7875[3] == 2) {
        p9588.send("so", v7875[0] || "nuke_0", v7875[1] || 1, 1, 0, 0, 0, v7875[2] || 1, null, null, !!v7875[4]);
      } else {
        var v7876 = v7875[3] && p9588;
        var v7877 = v7876 ? p9588 : p9589;
        p9588.send("s", v7875[0] || "nuke_0", v7877.sid, Math.round(v7877.x), Math.round(v7876 ? v7877.y + v7877.height : v7877.y), Math.round(v7877.z), v7875[1] || 1, v7875[2] || 1, null, null, !v7876, !!v7875[4]);
      }
    }
  }
}, {
  name: "Explosion",
  desc: "REPLACE",
  hasCust: true,
  actionValue: "Explosion Power",
  execute: function (p9591, p9592, p9593, p9594, p9595) {
    var v7878 = p9591.getActionValue(p9593, p9594, p9595, "number", p9595.trigConst || 100);
    if (v7878 != null) {
      p9591.explosion(p9594.x, p9594.y, p9594.z, 30, v7878, p9593, {});
    }
  }
}, {
  name: "Spawn AI",
  desc: "REPLACE",
  execute: function (p9596, p9597, p9598, p9599) {
    for (var vLN01281 = 0; vLN01281 < p9596.map.manager.pendingAIs.length; ++vLN01281) {
      var v7879 = p9596.map.manager.pendingAIs[vLN01281];
      var v7880 = v7879.data;
      if (v7880 && v7880.interface != p9599.interface && v7880.interface == p9599.interfaceT) {
        p9596.AI.spawn(null, 0, v7880.aiName, v7879.x, v7879.y, v7879.z, v7880);
      }
    }
  }
}, {
  name: "Set Player Value",
  desc: "REPLACE",
  type: "Both",
  actionValueTxt: "Key",
  actionValue: "Value",
  execute: function (p9600, p9601, p9602, p9603, p9604) {
    if (p9602 && p9604.trigConstTx && p9604.trigConstTx.length && p9602.custVals) {
      var v7881 = p9604.trigConstTx + "";
      var v7882 = p9604.trigConst || 0;
      if (p9602.custVals[v7881] == null) {
        if (Object.keys(p9602.custVals).length > config.custValLimit) {
          return;
        }
        p9602.custVals[v7881] = 0;
      }
      p9602.custVals[v7881] = parseFloat(v7882) || 0;
      p9602.send("cv", v7881, p9602.custVals[v7881]);
    }
  }
}, {
  name: "Inc/Dec Player Value",
  desc: "REPLACE",
  type: "Both",
  actionValueTxt: "Key",
  actionValue: "Value",
  execute: function (p9605, p9606, p9607, p9608, p9609) {
    if (p9607 && p9609.trigConstTx && p9609.trigConstTx.length && p9607.custVals) {
      var v7883 = p9609.trigConstTx + "";
      var v7884 = p9609.trigConst || 0;
      if (p9607.custVals[v7883] == null) {
        if (Object.keys(p9607.custVals).length > config.custValLimit) {
          return;
        }
        p9607.custVals[v7883] = 0;
      }
      p9607.custVals[v7883] += parseFloat(v7884) || 0;
      p9607.send("cv", v7883, p9607.custVals[v7883]);
    }
  }
}, {
  name: "Play Animation",
  desc: "REPLACE",
  type: "Both",
  actionValueTxt: "Clip",
  actionValue: "Interface ID",
  execute: function (p9610, p9611, p9612, p9613, p9614, p9615) {
    if (p9614.trigConstTx && p9614.trigConstTx.length) {
      var v7888;
      var v7886 = p9614.trigConstTx + "";
      var v7887 = p9614.trigConst || 0;
      for (var vLN01283 = 0; vLN01283 < p9610.AI.ais.length; ++vLN01283) {
        v7888 = p9610.AI.ais[vLN01283];
        if (v7888.active && v7888.interface == v7887) {
          p9610.AI.playAnim(v7888, v7886, 1, true);
        }
      }
      var v7888;
      for (var vLN01283 = 0; vLN01283 < p9610.map.manager.interfaces.length && !(p9610.triggerChains[p9615] <= 0); ++vLN01283) {
        v7888 = p9610.map.manager.objects[p9610.map.manager.interfaces[vLN01283]];
        if (v7888.sid != p9613.sid && v7888.interface != p9613.interface && v7888.interface == v7887) {
          p9610.playAnim(v7888, v7886, 1, true);
        }
      }
    }
  }
}, {
  name: "Teleport Player to Path Node",
  desc: "REPLACE",
  hasCust: true,
  actionValue: "Node ID",
  execute: function (game, p9617, p9618, p9619, p9620) {
    var v7889 = game.getActionValue(p9618, p9619, p9620, "number", p9620.trigConst || 0);
    if (v7889 != null) {
      var vParseInt12 = parseInt(v7889);
      var v7890 = game.map.manager.pathNodes[vParseInt12];
      if (v7890) {
        game.players.changePosition(p9618, v7890.x, v7890.y, v7890.z, true, true, undefined, true);
      }
    }
  }
}, {
  name: "Teleport Destructible Interface to Path Node",
  desc: "REPLACE",
  hasCust: true,
  actionValue: "Node ID",
  execute: function (p9621, p9622, p9623, p9624, p9625, p9626) {
    for (var vLN01284 = 0; vLN01284 < p9621.map.manager.interfaces.length && !(p9621.triggerChains[p9626] <= 0); ++vLN01284) {
      var v7891 = p9621.map.manager.objects[p9621.map.manager.interfaces[vLN01284]];
      if ((p9624.isAI || v7891.sid != p9624.sid) && v7891.interface != p9624.interface && v7891.interface == p9624.interfaceT) {
        var v7892 = p9621.getActionValue(p9623, v7891, p9625, "number", p9625.trigConst || 0);
        if (v7892 == null) {
          continue;
        }
        var vParseInt13 = parseInt(v7892);
        var v7893 = p9621.map.manager.pathNodes[vParseInt13];
        if (!v7893) {
          return;
        }
        p9621.teleportToNode(v7891.uid, vParseInt13);
      }
    }
  }
}, {
  name: "Reset Destructible Interface Position",
  desc: "REPLACE",
  execute: function (p9627, p9628, p9629, p9630, p9631, p9632) {
    for (var vLN01285 = 0; vLN01285 < p9627.map.manager.interfaces.length && !(p9627.triggerChains[p9632] <= 0); ++vLN01285) {
      var v7894 = p9627.map.manager.objects[p9627.map.manager.interfaces[vLN01285]];
      if ((p9630.isAI || v7894.sid != p9630.sid) && v7894.interface != p9630.interface && v7894.interface == p9630.interfaceT) {
        p9627.teleportFromNode(v7894.uid);
      }
    }
  }
}, {
  name: "Set Interface Trigger Value",
  desc: "REPLACE",
  type: "Both",
  actionValueTxt: "Key",
  actionValue: "Value",
  execute: function (p9633, p9634, p9635, p9636, p9637, p9638) {
    if (p9637.trigConstTx && p9637.trigConstTx.length) {
      var v7895 = p9637.trigConstTx + "";
      if (v7895 && UTILS.isString(v7895) && v7895.length) {
        var v7896;
        var v7897 = p9637.trigConst || 0;
        for (var vLN01286 = 0; vLN01286 < p9633.map.manager.interfaces.length && !(p9633.triggerChains[p9638] <= 0); ++vLN01286) {
          v7896 = p9633.map.manager.objects[p9633.map.manager.interfaces[vLN01286]];
          if (v7896 && (p9636.isAI || v7896.sid != p9636.sid) && v7896.interface != p9636.interface && v7896.interface == p9636.interfaceT) {
            if (!v7896.custVals) {
              continue;
            }
            if (v7896.custVals[v7895] == null) {
              if (Object.keys(v7896.custVals).length > config.custValLimit) {
                return;
              }
              v7896.custVals[v7895] = 0;
            }
            v7896.custVals[v7895] = parseFloat(v7897) || 0;
            if (v7896.custVals[v7895] == (v7896.trigConstE || 0) && v7896.onCustomValEquals) {
              p9633.onTrigger(p9635, v7896, p9638);
            }
            if (v7896.custVals[v7895] > (v7896.trigConstE || 0) && v7896.onCustomValGreater) {
              p9633.onTrigger(p9635, v7896, p9638);
            }
            if (v7896.custVals[v7895] < (v7896.trigConstE || 0) && v7896.onCustomValLesser) {
              p9633.onTrigger(p9635, v7896, p9638);
            }
          }
        }
      }
    }
  }
}, {
  name: "Inc/Dec Interface Trigger Value",
  desc: "REPLACE",
  type: "Both",
  actionValueTxt: "Key",
  actionValue: "Value",
  execute: function (p9639, p9640, p9641, p9642, p9643, p9644) {
    if (p9643.trigConstTx && p9643.trigConstTx.length) {
      var v7898 = p9643.trigConstTx + "";
      if (v7898 && UTILS.isString(v7898) && v7898.length) {
        var v7899;
        var v7900 = p9643.trigConst || 0;
        for (var vLN01287 = 0; vLN01287 < p9639.map.manager.interfaces.length && !(p9639.triggerChains[p9644] <= 0); ++vLN01287) {
          v7899 = p9639.map.manager.objects[p9639.map.manager.interfaces[vLN01287]];
          if (v7899 && (p9642.isAI || v7899.sid != p9642.sid) && v7899.interface != p9642.interface && v7899.interface == p9642.interfaceT) {
            if (!v7899.custVals) {
              continue;
            }
            if (v7899.custVals[v7898] == null) {
              if (Object.keys(v7899.custVals).length > config.custValLimit) {
                return;
              }
              v7899.custVals[v7898] = 0;
            }
            v7899.custVals[v7898] += v7900;
            if (v7899.custVals[v7898] == (v7899.trigConstE || 0) && v7899.onCustomValEquals) {
              p9639.onTrigger(p9641, v7899, p9644);
            }
            if (v7899.custVals[v7898] > (v7899.trigConstE || 0) && v7899.onCustomValGreater) {
              p9639.onTrigger(p9641, v7899, p9644);
            }
            if (v7899.custVals[v7898] < (v7899.trigConstE || 0) && v7899.onCustomValLesser) {
              p9639.onTrigger(p9641, v7899, p9644);
            }
          }
        }
      }
    }
  }
}, {
  name: "Set Trigger Value (Self)",
  desc: "REPLACE",
  type: "Both",
  actionValueTxt: "Key",
  actionValue: "Value",
  execute: function (p9645, p9646, p9647, p9648, p9649) {
    if (p9649.trigConstTx && p9649.trigConstTx.length && p9648) {
      var v7901 = p9649.trigConstTx + "";
      if (v7901 && UTILS.isString(v7901) && v7901.length) {
        var v7902 = p9649.trigConst || 0;
        if (p9648.custVals != null) {
          if (p9648.custVals[v7901] == null) {
            if (Object.keys(p9648.custVals).length > config.custValLimit) {
              return;
            }
            p9648.custVals[v7901] = 0;
          }
          p9648.custVals[v7901] = v7902;
        }
      }
    }
  }
}, {
  name: "Inc/Dec Trigger Value (Self)",
  desc: "REPLACE",
  type: "Both",
  actionValueTxt: "Key",
  actionValue: "Value",
  execute: function (p9650, p9651, p9652, p9653, p9654) {
    if (p9654.trigConstTx && p9654.trigConstTx.length && p9653) {
      var v7903 = p9654.trigConstTx + "";
      if (v7903 && UTILS.isString(v7903) && v7903.length) {
        var v7904 = p9654.trigConst || 0;
        if (p9653.custVals[v7903] == null) {
          if (Object.keys(p9653.custVals).length > config.custValLimit) {
            return;
          }
          p9653.custVals[v7903] = 0;
        }
        p9653.custVals[v7903] += v7904;
      }
    }
  }
}, {
  name: "Change Class",
  desc: "REPLACE",
  actionValue: "Class Index",
  actionOptions: Object.keys(classes).map(p9655 => classes[p9655].name),
  execute: function (p9656, p9657, p9658, p9659, p9660) {
    if (p9658) {
      var v7905 = parseInt(p9660.trigConst) || 0;
      if (p9656.classes[v7905] && p9658.classIndex != v7905) {
        p9658.classIndex = v7905;
        p9658.updateItems(p9656, p9657, true, undefined, undefined, true);
      }
    }
  }
}, {
  name: "Set Interface Deposit Box Amount",
  desc: "REPLACE",
  hasCust: true,
  execute: function (p9661, p9662, p9663, p9664, p9665, p9666) {
    for (var vLN01288 = 0; vLN01288 < p9661.map.manager.interfaces.length && !(p9661.triggerChains[p9666] <= 0); ++vLN01288) {
      var v7906 = p9661.map.manager.objects[p9661.map.manager.interfaces[vLN01288]];
      if ((p9664.isAI || v7906.sid != p9664.sid) && v7906.interface != p9664.interface && v7906.interface == p9664.interfaceT && v7906.bank) {
        var v7907 = p9661.getActionValue(p9663, v7906, p9665, "number", p9665.trigConst || 0);
        if (v7907 == null) {
          continue;
        }
        v7906.deposited = v7907;
        p9661.broadcast("bnk", v7906.uid, v7906.deposited);
      }
    }
  }
}, {
  name: "Save Data",
  desc: "REPLACE",
  hasCust: true,
  bypassType: true,
  type: "Both",
  actionValueTxt: "Data Name",
  hasExtra: true,
  actionValue2: "Save Type",
  actionOptions2: ["Set Value", "Set If Higher", "Set If Lower", "Increase Value", "Decrease Value"],
  execute: function (p9667, p9668, p9669, p9670, p9671) {
    if ((!p9667 || !p9667.isSandbox) && p9669 && p9669.account && (p9667.defaultSetts || !config.isProd) && p9671.trigConstTx && p9671.trigConstTx.length) {
      var v7908 = p9671.trigConstTx + "";
      if (v7908 && UTILS.isString(v7908) && v7908.length) {
        v7908 = v7908.toLowerCase().substring(0, 12);
        var v7909 = UTILS.limitMM(parseInt(p9671.trigConst2 || 0) || 0, 0, 5);
        var v7910 = p9667.getActionValue(p9669, p9670, p9671, "number", p9671.trigConst || 1);
        if (v7908 == "time") {
          var v7911 = p9669.gameTime || p9667.gameTimerP || 0;
          v7910 = v7911 && UTILS.isNumber(v7911) ? v7911 : undefined;
        }
        if (v7910 != null) {
          p9667.storageUpdt(p9669.account.name, null, v7909, "private", function () {}, v7908 + "," + v7910);
        }
      }
    }
  }
}, {
  name: "Change Primary Weapon",
  desc: "REPLACE",
  actionValue: "Weapon",
  actionOptions: Object.keys(weapons).filter(p9672 => weapons[p9672].name).map(p9673 => weapons[p9673].name),
  execute: function (p9674, p9675, p9676, p9677, p9678) {
    if (p9676) {
      var vParseInt14 = parseInt(p9678.trigConst || 0);
      if (p9674.weaponConfig[vParseInt14]) {
        var v7912 = p9674.weaponConfig[vParseInt14];
        if (!v7912.secondary && !v7912.melee) {
          var v7913;
          var v7914 = false;
          for (var vLN01289 = 0; vLN01289 < p9676.loadout.length; vLN01289++) {
            v7913 = p9674.weaponConfig[p9676.loadout[vLN01289]];
            if (!v7913.secondary && !v7913.melee && !v7913.equipment) {
              if (v7913.id == v7912.id) {
                return;
              }
              p9676.loadout[vLN01289] = v7912.id;
              v7914 = true;
              break;
            }
          }
          if (!v7914) {
            p9676.loadout.splice(0, 0, v7912.id);
          }
          p9676.updateLoadout(p9674, p9676.loadoutIndex, true, p9676.loadout);
          p9674.broadcast("inat", p9676.sid, p9676.loadout, p9676.loadoutIndex, undefined, undefined, false);
        }
      }
    }
  }
}, {
  name: "Change Secondary Weapon",
  desc: "REPLACE",
  actionValue: "Weapon",
  actionOptions: Object.keys(weapons).filter(p9679 => weapons[p9679].name).map(p9680 => weapons[p9680].name),
  execute: function (p9681, p9682, p9683, p9684, p9685) {
    if (p9683) {
      var vParseInt15 = parseInt(p9685.trigConst || 0);
      if (p9681.weaponConfig[vParseInt15]) {
        var v7915 = p9681.weaponConfig[vParseInt15];
        if (v7915.secondary) {
          var v7916;
          var v7917 = false;
          for (var vLN01290 = 0; vLN01290 < p9683.loadout.length; vLN01290++) {
            v7916 = p9681.weaponConfig[p9683.loadout[vLN01290]];
            if (v7916.secondary) {
              if (v7916.id == v7915.id) {
                return;
              }
              p9683.loadout[vLN01290] = v7915.id;
              v7917 = true;
              break;
            }
          }
          if (!v7917) {
            p9683.loadout.splice(p9683.loadout.length > 1 ? 1 : 0, 0, v7915.id);
          }
          p9683.updateLoadout(p9681, p9683.loadoutIndex, true, p9683.loadout);
          p9681.broadcast("inat", p9683.sid, p9683.loadout, p9683.loadoutIndex, undefined, undefined, false);
        }
      }
    }
  }
}, {
  name: "Set Global Value",
  desc: "REPLACE",
  type: "Both",
  actionValueTxt: "Key",
  actionValue: "Value",
  execute: function (p9686, p9687, p9688, p9689, p9690) {
    if (p9690.trigConstTx && p9690.trigConstTx.length) {
      var v7918 = p9690.trigConstTx + "";
      if (v7918 && UTILS.isString(v7918) && v7918.length) {
        var v7919 = p9690.trigConst || 0;
        if (p9686.globalVals != null) {
          if (p9686.globalVals[v7918] == null) {
            if (Object.keys(p9686.globalVals).length > config.custValLimit) {
              return;
            }
            p9686.globalVals[v7918] = 0;
          }
          p9686.globalVals[v7918] = v7919;
          p9686.broadcast("gv", v7918, p9686.globalVals[v7918]);
        }
      }
    }
  }
}, {
  name: "Change Global Value",
  desc: "REPLACE",
  type: "Both",
  actionValueTxt: "Key",
  actionValue: "Value",
  execute: function (p9691, p9692, p9693, p9694, p9695) {
    if (p9695.trigConstTx && p9695.trigConstTx.length) {
      var v7920 = p9695.trigConstTx + "";
      if (v7920 && UTILS.isString(v7920) && v7920.length) {
        var v7921 = p9695.trigConst || 0;
        if (p9691.globalVals[v7920] == null) {
          if (Object.keys(p9691.globalVals).length > config.custValLimit) {
            return;
          }
          p9691.globalVals[v7920] = 0;
        }
        p9691.globalVals[v7920] += v7921;
        p9691.broadcast("gv", v7920, p9691.globalVals[v7920]);
      }
    }
  }
}, {
  name: "Stop Sound",
  desc: "REPLACE",
  hasSound: true,
  execute: function (p9696, p9697, p9698, p9699, p9700) {
    var v7922 = p9700.triggerSound || vA389;
    p9696.broadcast("sso", v7922[0] || "nuke_0", !!v7922[4]);
  }
}, {
  name: "Show/Hide GUI Element (All)",
  desc: "REPLACE",
  hasExtra: true,
  actionValue: "Element ID",
  actionValue2: "Status",
  actionOptions2: ["Toggle", "Show", "Hide"],
  execute: function (p9701, p9702, p9703, p9704, p9705) {
    if (p9701) {
      var v7923 = parseInt(p9705.trigConst || 0) || 0;
      var v7924 = parseInt(p9705.trigConst2 || 0) || 0;
      p9701.broadcast("tgui", v7923, v7924);
    }
  }
}, {
  name: "Show/Hide GUI Element (Player)",
  desc: "REPLACE",
  hasExtra: true,
  actionValue: "Element ID",
  actionValue2: "Status",
  actionOptions2: ["Toggle", "Show", "Hide"],
  execute: function (p9706, p9707, p9708, p9709, p9710) {
    if (p9706 && p9708) {
      var v7925 = parseInt(p9710.trigConst || 0) || 0;
      var v7926 = parseInt(p9710.trigConst2 || 0) || 0;
      p9708.send("tgui", v7925, v7926);
    }
  }
}, {
  name: "Load Data",
  desc: "REPLACE",
  execute: function (p9711, p9712, p9713) {
    if ((!p9711 || !p9711.isSandbox) && !!p9713 && !!p9713.account && !!p9711.defaultSetts) {
      p9711.getStoragePlayer(p9713.account.name, null, function (p9714) {
        if (p9713.custVals && p9714 && p9714.length) {
          for (var vLN01291 = 0; vLN01291 < p9714.length; vLN01291++) {
            var v7927 = p9714[vLN01291].mk;
            var v7928 = p9714[vLN01291].kv;
            if (p9713.custVals[v7927] == null) {
              if (Object.keys(p9713.custVals).length > config.custValLimit) {
                return;
              }
              p9713.custVals[v7927] = 0;
            }
            p9713.custVals[v7927] = isNaN(parseFloat(v7928)) ? v7928 : parseFloat(v7928);
            p9713.send("cv", v7927, p9713.custVals[v7927]);
          }
        }
      });
    }
  }
}, {
  name: "Custom Action",
  desc: "REPLACE",
  hasExtra: true,
  type: "Text",
  actionValueTxt: "Custom Param",
  execute: function (p9715, p9716, p9717, p9718, p9719) {
    if (p9715 && p9715.mainScript && p9715.mainScript.onCustomTrigger) {
      var vLS25 = "";
      if (p9719.trigConstTx && p9719.trigConstTx.length) {
        vLS25 = p9719.trigConstTx + "";
      }
      var v7929 = parseInt(p9719.trigConst || 0) || 0;
      p9715.mainScript.onCustomTrigger(p9717 ? p9717.id : "NONE", vLS25, v7929);
    }
  }
}, {
  name: "Reward Junk",
  desc: "REPLACE",
  type: "Text",
  actionValueTxt: "Amount",
  devOnly: true,
  execute: function (p9720, p9721, p9722, p9723, p9724) {
    if ((!p9720 || !p9720.isSandbox) && p9722 && p9720.isPubType() && p9722.account) {
      var vParseFloat = parseFloat(p9724.trigConstTx || 0);
      if (!!vParseFloat && !(vParseFloat >= 100)) {
        p9720.sendUserJunk("trigger", p9722, vParseFloat);
      }
    }
  }
}, {
  name: "Reward Skin",
  desc: "REPLACE",
  type: "Text",
  actionValueTxt: "Ids",
  devOnly: true,
  execute: function (p9725, p9726, p9727, p9728, p9729) {
    if ((!p9725 || !p9725.isSandbox) && p9727 && p9725.isPubType() && p9727.account) {
      var v7930;
      for (var v7931 = ((p9729.trigConstTx || "") + "").split(","), vA390 = [], vLN01292 = 0, v7932 = UTILS.randFloat(0, 100).round(2), vLN01293 = 0; vLN01293 < v7931.length; vLN01293++) {
        v7930 = v7931[vLN01293].split("|");
        if (!v7930[1]) {
          vA390.push(v7930[0]);
        } else {
          vLN01292 += parseFloat(v7930[1]);
          if (v7932 <= vLN01292) {
            vA390.push(v7930[0]);
            break;
          }
        }
      }
      if (vA390.length) {
        p9725.giveSkin(p9727, vA390.join(","), "trigger");
      }
    }
  }
}, {
  name: "Change Ambient Sound",
  desc: "REPLACE",
  actionValue: "Ambient Sound",
  actionOptions: Object.keys(config.soundScapes).map(p9730 => p9730),
  execute: function (p9731, p9732, p9733, p9734, p9735) {
    var vParseInt16 = parseInt(p9735.trigConst || 0);
    var v7933 = Object.keys(config.soundScapes);
    if (v7933[vParseInt16]) {
      p9731.broadcast("camb", config.soundScapes[v7933[vParseInt16]]);
    }
  }
}, {
  name: "Give Challenge Progress",
  desc: "REPLACE",
  actionValue: "Prog",
  devOnly: true,
  type: "Both",
  actionValueTxt: "Key",
  execute: function (p9736, p9737, p9738, p9739, p9740) {
    if ((!p9736 || !p9736.isSandbox) && p9738 && p9736.isPubType() && p9738.account) {
      var vLS26 = "";
      if (p9740.trigConstTx && p9740.trigConstTx.length) {
        vLS26 = p9740.trigConstTx + "";
      }
      if (vLS26.length) {
        var vParseInt17 = parseInt(p9740.trigConst || 0);
        p9736.challenges.update(p9736, vLS26, vParseInt17, null, p9738);
      }
    }
  }
}, {
  name: "Play Animation (Self)",
  desc: "REPLACE",
  type: "Text",
  actionValueTxt: "Clip",
  execute: function (p9741, p9742, p9743, p9744, p9745) {
    if (p9745.trigConstTx && p9745.trigConstTx.length) {
      var v7934 = p9745.trigConstTx + "";
      p9741.playAnim(p9744, v7934, 1, true);
    }
  }
}, {
  name: "Give Effect",
  desc: "REPLACE",
  actionValue: "Effect",
  actionOptions: Object.keys(effects).map(p9746 => effects[p9746].name),
  execute: function (game, p9748, p9749, p9750, p9751) {
    if (p9749) {
      var vParseInt18 = parseInt(p9751.trigConst || 0);
      if (effects[vParseInt18]) {
        game.players.giveEffect(p9749, vParseInt18);
      }
    }
  }
}, {
  name: "Give Challenge Progress (All)",
  desc: "REPLACE",
  actionValue: "Prog",
  devOnly: true,
  type: "Both",
  actionValueTxt: "Key",
  execute: function (game, p9753, p9754, p9755, p9756) {
    if ((!game || !game.isSandbox) && p9754 && game.isPubType() && p9754.account) {
      var vLS27 = "";
      if (p9756.trigConstTx && p9756.trigConstTx.length) {
        vLS27 = p9756.trigConstTx + "";
      }
      if (vLS27.length) {
        var vParseInt19 = parseInt(p9756.trigConst || 0);
        for (var vLN01294 = 0; vLN01294 < game.players.list.length; vLN01294++) {
          if (game.players.list[vLN01294] && game.players.list[vLN01294].active && !game.players.list[vLN01294].spectating) {
            game.challenges.update(game, vLS27, vParseInt19, null, game.players.list[vLN01294]);
          }
        }
      }
    }
  }
}, {
  name: "Give Random Effect",
  desc: "REPLACE",
  execute: function (game, p9758, p9759) {
    if (p9759) {
      game.players.giveEffect(p9759, 0, 1, true);
    }
  }
}, {
  name: "Play Video Ad",
  desc: "REPLACE",
  execute: function (p9760, p9761, p9762) {
    if ((!p9760 || !p9760.isSandbox) && !!p9762 && !!p9761) {
      p9762.send("vad");
    }
  }
}, {
  name: "Drop Powerup",
  devOnly: true,
  desc: "REPLACE",
  execute: function (p9763, p9764, p9765, p9766) {
    if (p9763 && p9763.mode && p9763.mode.id == "zom" && (!p9763 || !p9763.isCustom || !!p9763.mimicPubs)) {
      var v7935 = UTILS.randInt(9, 15);
      p9763.dropSpawnable(v7935, p9765, null, {
        x: p9766.x,
        y: p9766.y,
        z: p9766.z
      });
    }
  }
}, {
  name: "Spawn Bot at Node",
  desc: "REPLACE",
  devOnly: true,
  hasCust: true,
  execute: function (game, p9768, p9769, p9770, p9771) {
    if ((!game || !game.isCustom || !!game.mimicPubs) && p9769) {
      var v7936 = game.getActionValue(p9769, p9770, p9771, "number", p9771.trigConst || 0);
      if (v7936 != null) {
        var vParseInt20 = parseInt(v7936);
        var v7937 = game.map.manager.pathNodes[vParseInt20];
        if (v7937) {
          var v7938 = game.bots.add(v7937, true, true, {
            name: "Uncle Joe",
            forceClass: true,
            primSkin: 5076,
            dye: 1075,
            lives: 1,
            face: 5078,
            hat: 5077,
            back: 5079,
            waist: 5080,
            class: 4,
            targetBots: false,
            targetTeam: false,
            forceCrouch: false,
            attackTarget: true,
            followTarget: true,
            watchTarget: true,
            mimicTarget: false,
            slideHop: false,
            canRespawn: true,
            useSpawnDelay: true,
            removeOnDeath: true,
            nodYes: false,
            nodNo: false,
            joinMessage: false,
            leaveMessage: false,
            voiceChat: false,
            godMode: false,
            roam: true
          });
          v7938.scoreOnDeath = true;
          v7938.player.maxHealth = 1000;
          v7938.player.health = v7938.player.maxHealth;
          game.broadcast("h", v7938.player.health, v7938.player.sid, null, null, true, true);
          game.players.giveWeapon(v7938.player, 5);
          game.bots.sync();
        }
      }
    }
  }
}, {
  name: "Force AI Target",
  desc: "REPLACE",
  execute: function (p9772, p9773, p9774, p9775) {
    p9772.AI.forceTargetTimer = 30000;
    p9772.AI.forceTarget = {
      x: p9775.x,
      y: p9775.y,
      z: p9775.z
    };
  }
}, {
  name: "Mode Specific",
  desc: "REPLACE",
  execute: function (p9776, p9777, p9778, p9779) {
    if (p9776 && p9776.mode && p9776.mode.onTrigger) {
      p9776.mode.onTrigger(p9776, p9779);
    }
  }
}];